import * as yup from 'yup';

export const transferAccountValidation = yup.object().shape({
  selectedAccount: yup
    .object()
    .nullable()
    .required('Please, select an account'),
});
